import Vue, { VueConstructor } from 'vue';
import VueRouter, { Route } from 'vue-router';
import store from '@/store';

import Home from '@/views/Home.vue';
import NotAuthorized from '@/views/NotAuthorized.vue';
import QuestionsList from '@/bundles/Questions/views/QuestionsList.vue';
import IntroList from '@/views/Session/IntroList.vue';
import ExerciseList from '@/views/Exercise/ExerciseList.vue';
import HomeworkList from '@/views/Homework/HomeworkList.vue';
import ProviderList from '@/views/Provider/ProviderList.vue';

import ScheduleList from '@/views/Schedule/ScheduleList.vue';
import CouponList from '@/views/Coupon/CouponList.vue';

import Redeem from '@/views/Redeem.vue';
import UsersManagement from '@/bundles/Users/views/UsersManagement.vue';
import Users from '@/bundles/Users/views/Users.vue';
import Survey from '@/bundles/Users/views/Survey.vue';

import WarmUps from '@/bundles/WarmUp/views/WarmUps.vue';
import SessionList from '@/bundles/Session/views/SessionList.vue';
import CategoryListView from '@/bundles/Category/views/CategoryListView.vue';

import BadgesList from '@/bundles/Badge/views/BadgesList.vue';

import AdListView from '@/bundles/Ad/views/AdListView.vue';
import AdAdminView from '@/bundles/Ad/views/AdAdminView.vue';
import AdAdminCampaignsView from '@/bundles/Ad/views/AdAdminCampaignsView.vue';
import AdAdminClientsView from '@/bundles/Ad/views/AdAdminClientsView.vue';
import AdAdminCampaignView from '@/bundles/Ad/views/AdAdminCampaignView.vue';

import ActivityGroupList from '@/bundles/ActivityGroup/views/ActivityGroupList.vue';
import VoiceBuilderList from '@/bundles/ActivityGroup/views/VoiceBuilderList.vue';
import PhysicalExerciseList from '@/bundles/ActivityGroup/views/PhysicalExerciseList.vue';
import VoiceClassList from '@/bundles/ActivityGroup/views/VoiceClassList.vue';
import WeeklyChallengeList from '@/bundles/ActivityGroup/views/WeeklyChallengeList.vue';
import WeeklyChallengeOrderList from '@/bundles/ActivityGroup/views/WeeklyChallengeOrderList.vue';

import VideoContent from '@/bundles/VideoContent/views/VideoContent.vue';
import PhysicalExercise from '@/bundles/VideoContent/views/PhysicalExercise.vue';
import VoiceClass from '@/bundles/VideoContent/views/VoiceClass.vue';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: any) {
  // @ts-ignore
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home as VueConstructor
  },
  {
    path: '/login',
    name: 'not-authorized',
    component: NotAuthorized as VueConstructor
  },
  {
    path: '/question',
    name: 'question',
    component: QuestionsList as VueConstructor
  },
  {
    path: '/intros',
    name: 'intros',
    component: IntroList as VueConstructor
  },
  {
    path: '/session',
    name: 'session',
    component: SessionList as VueConstructor
  },
  {
    path: '/exercise',
    name: 'exercise',
    component: ExerciseList as VueConstructor
  },
  {
    path: '/homework',
    name: 'homework',
    component: HomeworkList as VueConstructor
  },
  {
    path: '/provider',
    name: 'provider',
    component: ProviderList as VueConstructor,
    beforeEnter: function(to: Route, from: Route, next: Function) {
      // @ts-ignore
      if (store.state.user.role === 'admin') {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: CouponList as VueConstructor,
    beforeEnter: function(to: Route, from: Route, next: Function) {
      // @ts-ignore
      if (store.state.user.role === 'admin') {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: ScheduleList as VueConstructor
  },
  {
    path: '/redeem',
    name: 'redeem',
    component: Redeem as VueConstructor
  },
  {
    path: '/users',
    component: UsersManagement,
    children: [
      {
        path: '',
        name: 'users-list',
        component: Users,
      },
      {
        path: 'survey',
        name: 'users-survey',
        component: Survey,
      },
    ]
  },
  {
    path: '/warm-up',
    name: 'warm-up',
    component: WarmUps as VueConstructor
  },
  {
    path: '/category',
    name: 'category',
    component: CategoryListView as VueConstructor
  },
  {
    path: '/badge',
    name: 'badges',
    component: BadgesList as VueConstructor
  },
  {
    path: '/ad',
    name: 'ad-list',
    component: AdListView as VueConstructor
  },
  {
    path: '/activity-group',
    component: ActivityGroupList,
    children: [
      {
        path: '',
        name: 'voice-builder',
        component: VoiceBuilderList,
      },
      {
        path: 'physical',
        name: 'physical',
        component: PhysicalExerciseList,
      },
      {
        path: 'voice-class',
        name: 'voice-class',
        component: VoiceClassList,
      },
      {
        path: 'weekly-challenge',
        name: 'weekly-challenge',
        component: WeeklyChallengeOrderList,
      },
    ]
  },
  {
    path: '/content-management',
    component: VideoContent,
    children: [
      {
        path: '',
        name: 'physical-content',
        component: PhysicalExercise,
      },
      {
        path: 'voice',
        name: 'voice-content',
        component: VoiceClass,
      },
      {
        path: 'weekly-challenge',
        name: 'weekly-challenge-content',
        component: WeeklyChallengeList,
      },
    ],
  },
  {
    path: '/ad-admin',
    component: AdAdminView,
    children: [
      {
        path: '',
        name: 'ad-admin-campaigns',
        component: AdAdminCampaignsView,
      },
      {
        path: 'clients',
        name: 'ad-admin-clients',
        component: AdAdminClientsView,
      },
      {
        path: ':id',
        name: 'ad-admin-campaign',
        props: true,
        component: AdAdminCampaignView,
      }
    ]
  }
];

const router = new VueRouter({
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (
    store.state.user ||
    to.name === 'not-authorized' ||
    to.name === 'redeem'
  ) {
    next();
  } else {
    next('/login');
  }
});

export default router;
